import styled from 'styled-components';
import type { MediaImageProps } from '@elfsight/widget-media';
import { MediaImage } from '@elfsight/widget-media';
import { Link } from '../../../lib/components';
import { getURLHostname } from '../../utils';
import { MediaContainer } from './MediaContainer';

type PickedMediaImageProps = Pick<
  MediaImageProps,
  'src' | 'onLoad' | 'onError' | 'mode'
>;

interface MediaLinkProps extends PickedMediaImageProps {
  url: string;
  title?: string;
  description?: string;
  thumbnail?: string;
  showDescription?: boolean;
  offset?: number;
  textColor?: string;
}

export function MediaLink({
  url,
  src,
  onLoad,
  onError,
  title,
  description,
  thumbnail,
  mode: mediaImageMode,
  showDescription = true,
  offset = 16,
  textColor = '#fff'
}: MediaLinkProps) {
  const host = getURLHostname(url);
  const showCaption = !!(title || (showDescription && !!description) || host);

  return (
    <MediaContainer backgroundImage={thumbnail || src}>
      <LinkContainer hoverEffect="none" href={url}>
        {!!(thumbnail || src) && (
          <MediaImage
            src={thumbnail || src}
            alt={title}
            onLoad={onLoad}
            onError={onError}
            mode={mediaImageMode}
          />
        )}

        {showCaption && (
          <Caption _offset={offset} _textColor={textColor}>
            {!!title && <CaptionTitle>{title}</CaptionTitle>}

            {!!description && showDescription && (
              <CaptionDescription>{description}</CaptionDescription>
            )}

            {!!host && <CaptionHost>{host}</CaptionHost>}
          </Caption>
        )}
      </LinkContainer>
    </MediaContainer>
  );
}

const Caption = styled.div<{
  _offset: number;
  _textColor: string;
}>`
  font-size: 13px;
  opacity: 0.7;
  padding: ${({ _offset }) => _offset}px;
  color: ${({ _textColor }) => _textColor};
`;
const CaptionTitle = styled.div`
  opacity: 1;
  font-weight: bold;
  margin-bottom: 4px;
`;
const CaptionDescription = styled.div`
  opacity: 0.7;
`;
const CaptionHost = styled.div`
  opacity: 0.7;
  text-transform: uppercase;
  margin-top: 4px;
`;

const LinkContainer = styled(Link)`
  display: block;
  width: 100%;

  &:hover ${CaptionHost} {
    text-decoration: underline;
  }
`;
